// React
import React, { useEffect, useRef } from "react";

// Libraries
import PropTypes from "prop-types";
import { GroupedVirtuoso } from "react-virtuoso";

// Context
import { useListRef } from "@Features/Monitor/Context";

// Components
import Text from "@Components/Text";
import Pill from "@Components/Pill";
import MessageCard from "../MessageCard";

// Styles
import styles from "./styles.module.css";

const SearchMessageList = ({ sectionsData, messagesData, dataCounts }) => {
	const { listRef } = useListRef();
	const searchListRef = useRef(null);

	useEffect(() => {
		if (searchListRef.current) {
			searchListRef?.current?.scrollToIndex({ index: messagesData.length, behavior: "smooth" });
		}
	}, [messagesData]);

	const handleFromSearch = async (item) => {
		await listRef?.current?.scrollToMessage(item.id);
	};

	const renderHeader = (index) => {
		return (
			<div className={styles.datePill}>
				<Pill>
					<Text className={styles.pillText}>{sectionsData[index]}</Text>
				</Pill>
			</div>
		);
	};

	const renderItem = (index) => {
		const item = messagesData[index];
		return (
			<MessageCard
				item={item}
				isSearched
				handleFromSearch={() => {
					return handleFromSearch(item);
				}}
			/>
		);
	};

	return (
		<div className={styles.fullSize}>
			<GroupedVirtuoso
				ref={searchListRef}
				groupCounts={dataCounts}
				groupContent={renderHeader}
				itemContent={renderItem}
				overscan={25}
				followOutput="smooth"
			/>
		</div>
	);
};

SearchMessageList.propTypes = {
	sectionsData: PropTypes.array,
	messagesData: PropTypes.array,
	dataCounts: PropTypes.array,
};

export default SearchMessageList;
